// extracted by mini-css-extract-plugin
export default {"submit":"Form_submit__qGJ1S","fieldsWrapper":"Form_fieldsWrapper__X4cVG","error":"Form_error__gN5fP"};